<template>
  <Dialog
    v-model:visible="isVisible"
    header="JSON Content"
    modal
    block-scroll
    :style="{ width: '50vw' }"
    dismissable-mask
    :draggable="false"
  >
    <JsonEditorVue
      v-model="localJsonContent"
      mode="text"
      :stringified="false"
      :read-only="readonly"
      :main-menu-bar="!readonly"
      v-bind="attrs"
    />
    <Button severity="secondary" icon="pi pi-copy" label="Copy" style="margin-top: 1rem" @click="copyJsonContent" />
    <Button
      v-if="!readonly"
      :disabled="hasError"
      severity="primary"
      label="Save"
      style="margin-left: 0.5rem"
      @click="saveJsonContent"
    />
  </Dialog>
</template>

<script setup lang="ts">
import JsonEditorVue from "json-editor-vue";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import { computed, ref, useAttrs, watch } from "vue";

const emit = defineEmits(["update:model-value", "close"]);

const props = defineProps({
  jsonContent: {
    type: String,
    default: "{}",
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  isVisible: {
    type: Boolean,
    default: false,
  },
});

const isVisible = computed({
  get: () => props.isVisible,
  set: () => {
    emit("close");
  },
});

const localJsonContent = ref(JSON.parse(props.jsonContent));
const attrs = useAttrs();
const hasError = ref(true);

const copyJsonContent = () => {
  navigator.clipboard.writeText(JSON.stringify(localJsonContent.value, null, 0));
};

const saveJsonContent = () => {
  emit("update:model-value", JSON.stringify(localJsonContent.value, null, 0));
  emit("close");
};

watch(
  () => props.jsonContent,
  (newValue) => {
    localJsonContent.value = JSON.parse(newValue);
  }
);

watch(
  () => localJsonContent.value,
  (newValue) => {
    if (newValue === undefined) {
      hasError.value = true;
    } else {
      hasError.value = false;
    }
  }
);
</script>

<style>
.jse-main {
  height: 500px !important;
}
</style>
